import { CustomTerm } from 'graphql/types';

export const replaceTerms = (
  localMessages: Record<string, string>,
  customTerms: CustomTerm[]
): Record<string, string> => {
  Object.keys(localMessages).forEach((key) => {
    localMessages[key] = customTerms.reduce(
      (msg, term) =>
        msg.replace(
          new RegExp(`(^|\\W)${term.originalTerm}($|\\W)`, 'gi'),
          `$1${term.customTerm}$2`
        ),

      localMessages[key]
    );
  });
  return localMessages;
};
